export enum ProfileAnalyticsEnum {
  PROFILE_VIEW_PAGE = '[PAC WEB] Meu Perfil - Página visualizada',
  PROFILE_CLICK_TAB_DATA = '[PAC WEB] Meu Perfil - Clicou na aba "Dados"',
  PROFILE_CLICK_TAB_PASSWORD = '[PAC WEB] Meu Perfil - Clicou na aba "Senha"',
  PROFILE_CLICK_TAB_OTHERS = '[PAC WEB] Meu Perfil - Clicou na aba "Outros"',
  PROFILE_TAB_CHANGE_WITH_UNSAVED_DATA = '[PAC WEB] Meu Perfil - Tentou trocar aba com dados não salvos',
  PROFILE_UNSAVED_DATA_DISCARD = '[PAC WEB] Meu Perfil - Descartou dados não salvos no modal',
  PROFILE_UNSAVED_DATA_KEEP_EDITING = '[PAC WEB] Meu Perfil - Continuou editando no modal',

  PROFILE_DATA_FORM_SUBMIT = '[PAC WEB] Meu Perfil - Dados - Atualizou perfil',
  PROFILE_DATA_UPDATE_SUCCESS = '[PAC WEB] Meu Perfil - Dados - Dados atualizados com sucesso',
  PROFILE_DATA_UPDATE_ERROR = '[PAC WEB] Meu Perfil - Dados - Erro ao atualizar dados',

  PROFILE_PASSWORD_FORM_SUBMIT = '[PAC WEB] Meu Perfil - Senha - Atualizou senha',
  PROFILE_PASSWORD_CHANGE_SUCCESS = '[PAC WEB] Meu Perfil - Senha - Senha alterada com sucesso',
  PROFILE_PASSWORD_CHANGE_ERROR = '[PAC WEB] Meu Perfil - Senha - Erro ao alterar senha',
  PROFILE_PASSWORD_CURRENT_INCORRECT = '[PAC WEB] Meu Perfil - Senha - Senha atual incorreta',

  PROFILE_OTHERS_CLICK_DELETE_ACCOUNT = '[PAC WEB] Meu Perfil - Outros - Clicou em "Excluir conta"',
  PROFILE_OTHERS_OPEN_DELETE_CONFIRMATION_SHEET = '[PAC WEB] Meu Perfil - Outros - Modal de exclusão de conta aberto',
  PROFILE_OTHERS_CONFIRM_DELETE_ACCOUNT = '[PAC WEB] Meu Perfil - Outros - Confirmou exclusão de conta no modal',
  PROFILE_OTHERS_CANCEL_DELETE_ACCOUNT = '[PAC WEB] Meu Perfil - Outros - Cancelou exclusão de conta no modal',
  PROFILE_OTHERS_CLICK_PRIVACY_POLICY = '[PAC WEB] Meu Perfil - Outros - Clicou em "Política de Privacidade" no modal de exclusão',
  PROFILE_OTHERS_DELETE_ACCOUNT_SUCCESS = '[PAC WEB] Meu Perfil - Outros - Conta excluída com sucesso',
  PROFILE_OTHERS_DELETE_ACCOUNT_ERROR = '[PAC WEB] Meu Perfil - Outros - Erro ao excluir conta',
  PROFILE_OTHERS_DELETE_ACCOUNT_INCORRECT_PASSWORD = '[PAC WEB] Meu Perfil - Outros - Senha incorreta ao excluir conta',

  CLICK_PROFILE_MENU_TALK_TO_US = '[PAC WEB] Menu do Perfil - Clicou em "Fale com a gente"',
}
